import { defineMessages } from 'react-intl';

export default defineMessages({
    firstName: {
        id: 'fnol.adac.contact-details-page.First name',
        defaultMessage: 'First name'
    },
    lastName: {
        id: 'fnol.adac.contact-details-page.Last name',
        defaultMessage: 'Last name'
    },
    mobileNumber: {
        id: 'fnol.adac.contact-details-page.Mobile',
        defaultMessage: 'Mobile',
    },
    repeatMobileNumber: {
        id: 'fnol.adac.contact-details-page.Repeat mobile',
        defaultMessage: 'Repeat mobile'
    },
    email: {
        id: 'fnol.adac.contact-details-page.E-Mail',
        defaultMessage: 'E-Mail',
    },
    repeatEmail: {
        id: 'fnol.adac.contact-details-page.Repeat E-Mail',
        defaultMessage: 'Repeat E-Mail'
    },
    differentMobileNumber: {
        id: 'fnol.adac.contact-details-page.Different mobile number',
        defaultMessage: 'The given phone numbers don\'t match. Please correct the phone numbers.'
    },
    differentEmailAddress: {
        id: 'fnol.adac.contact-details-page.Different Email addresses',
        defaultMessage: 'The given email addresses don\'t match. Please correct the email addresses.'
    },
    dateOfBirth: {
        id: 'fnol.adac.contact-details-page.Date of birth',
        defaultMessage: 'Date of birth'
    },
    remark: {
        id: 'fnol.adac.contact-details-page.Remark',
        defaultMessage: 'Remark'
    },
    noLeadingTrailingSpaces:{
        id: 'fnol.adac.contact-details-page.There must be no spaces before and after the value',
        defaultMessage: 'There must be no spaces before and after the value'
    }
});
